import { createFileRoute } from '@tanstack/react-router'
import { useStoreProjectModalTab } from '~/components/routes/development/real-estate/store-project/store-project-modal/modal-tab-context'
import { WorksTab } from '~/components/routes/development/real-estate/store-project/store-project-modal/works-tab'

export const Route = createFileRoute(
  '/_authenticated/development/real-estate/kanban/$cardId/works',
)({
  component: WorksTabRoute,
})

function WorksTabRoute() {
  const tab = useStoreProjectModalTab()
  return (
    <WorksTab
      form={tab.form}
      canEdit={tab.canEdit}
      onAutoDateModeChange={tab.handleAutoDateModeChange}
    />
  )
}
